/**
 * ECO Haustechnik — zentrale Section-Video-Konfiguration
 *
 * Hier liegen alle Autoplay-Videos der Website.
 * Zum Austauschen eines Clips einfach `src` (und optional `poster`) ersetzen —
 * z. B. nach eigenem Upload (BIM-Screen, Wärmepumpe, Technikraum, Automation-Panel).
 *
 * Konvention: Clips sollen stumm, kurz loopbar (10-20s) und im Breitformat (16:9 bis 21:9) sein.
 */

// Gemeinsamer Default-Clip (Emergent CDN) — wird ersetzt, sobald bereichsspezifische Clips vorliegen.
const DEFAULT_CLIP = "https://customer-assets.emergentagent.com/job_building-tech-neu/artifacts/q1nbilbz_74089e90-a0ba-4dd9-816e-392ee56c9f9b-h264-hd.mp4";

// ============================================================================
// HERO VIDEO (Startseite — über das ganze Hero-Bild)
// Eigenen Drohnenflug / Technikraum-Panning einfach die URL unten tauschen.
// Empfohlen: 10-20s Loop, horizontal, stumm, komprimiert (< 10 MB).
// ============================================================================
export const HERO_VIDEO = {
  src: DEFAULT_CLIP,
  poster: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1920&q=80",
};

// ============================================================================
// EXPLORER VIDEO (Startseite — "Technik, zum Erkunden" Haus-Grafik)
// Dezente Hintergrundatmosphäre hinter der interaktiven SVG-Hausgrafik.
// ============================================================================
export const EXPLORER_VIDEO = {
  src: DEFAULT_CLIP,
  poster: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1920&q=80",
};

export const EXPLORER_IMAGE = {
  src: "https://static.prod-images.emergentagent.com/jobs/6eeff79d-3898-4697-b107-96bb26575cb5/images/7b0e243d4a44ffb58718c46e1ea5ed5a1a7045afe291665fc19a200c1a297bd3.jpeg",
  alt: "Fotorealistischer Haus-Querschnitt mit Photovoltaik, Wärmepumpe, Speicher und Gebäudeautomation",
};

// ============================================================================
// COMPANY VIDEO (Unternehmen — "Ein Ansprechpartner ...")
// Ruhiger Technikclip für die große Medienfläche neben dem Missionstext.
// ============================================================================
export const COMPANY_VIDEO = {
  src: DEFAULT_CLIP,
  poster: "https://images.unsplash.com/photo-1761571740780-d9149a88b759?auto=format&fit=crop&w=1600&q=85",
};

export const SECTION_VIDEOS = {
  // Planung & BIM — zeigt BIM-Modell, technische Zeichnung, Koordination
  planungBim: {
    src: DEFAULT_CLIP,
    poster: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1920&q=80",
    badge: "BIM · Digitale Koordination",
    title: "Technik koordinieren, bevor sie gebaut wird.",
    subtitle: "Vom 3D-Modell über Leitungsführung bis Verteilerplanung — alle Gewerke in einem Modell.",
  },

  // Energie & Heizung — zeigt Wärmepumpe, PV, Technikraum
  energieHeizung: {
    src: DEFAULT_CLIP,
    poster: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1920&q=80",
    badge: "Wärmepumpe · PV · Speicher",
    title: "Ein Energie-Konzept für das ganze Gebäude.",
    subtitle: "Wärmepumpe, Photovoltaik, Speicher und Energiemanagement als abgestimmtes System.",
  },

  // Gebäudeautomation — zeigt Touchpanel, Bus-Verteiler, Sensorik, App
  gebaeudeautomation: {
    src: DEFAULT_CLIP,
    poster: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1920&q=80",
    badge: "Smart Building · Automation",
    title: "Technische Systeme, abgestimmt zu einem Ganzen.",
    subtitle: "Heizung, Licht, Beschattung, Zutritt und Energie — zentral gesteuert, visualisiert und per App bedient.",
  },

  // Wohnanlagen — zeigt moderne Mehrfamilienhäuser, Technikzentrale
  wohnanlagen: {
    src: DEFAULT_CLIP,
    poster: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1920&q=80",
    badge: "Bauträger · Hausverwaltung",
    title: "Zentrale Technik, wohnungsweise geregelt.",
    subtitle: "Von der Energiezentrale über die Wohnungsstation bis zur Verbrauchserfassung — eine integrierte Lösung.",
  },

  // Service & Wartung — zeigt Techniker, Inbetriebnahme, Prüfung
  service: {
    src: DEFAULT_CLIP,
    poster: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1920&q=80",
    badge: "Inbetriebnahme · Wartung",
    title: "Prüfen, einstellen, übergeben.",
    subtitle: "Von der ersten Funktionsprüfung über die Einschulung bis zur laufenden Betreuung Ihrer Anlage.",
  },
};
